import { type IAgentMatchQuery } from 'application/querySchemas/IAgentMatchQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentMatchListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAgentMatchListClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentMatchQuery implements IAgentMatchQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentMatchListClient')
        public readonly agentMatchListClient: IAgentMatchListClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentMatchListClient.get({
            token: this.agentUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
